import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
interface MessageSkeletonStyleProps {
  isYours: boolean
}
const useStyles = makeStyles<Theme, MessageSkeletonStyleProps>(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: ({ isYours }) => (isYours ? 'row-reverse' : 'row'),
    margin: '0.5rem 0',
    width: 300
  },

  avatarLoading: {
    animation: '$skeleton-loading 0.3s linear infinite alternate',
    borderRadius: '50%',

    '& > span': {
      width: '2rem',
      height: '2rem'
    }
  },

  msgContent: {
    margin: '0px 1rem',
    width: '50%',
    borderRadius: '10px',
    height: 45,
    animation: '$skeleton-loading 0.3s linear infinite alternate'
  },

  '@keyframes skeleton-loading': {
    '0%': {
      backgroundColor: 'hsl(0, 0%, 90%)'
    },
    '100%': {
      backgroundColor: 'hsl(0, 0%, 93%)'
    }
  }
}))

export default useStyles
